module.exports = __webpack_public_path__ + "static/media/18.85476b51.jpg";